export default __webpack_public_path__ + "static/media/transaction-report.bd3ea13b.svg";